const ROUTES = {
  LIST: "/api/icbc-data",
};

export default ROUTES;
